const DATA = "house_selected_data";
const STATUS = "house_selected_status";

const DANGER_DATA = 'danger_selected_data';
const DANGER_STATUS = 'danger_selected_status';

const SEWAGE_DATA = 'sewage_selected_data';
const SEWAGE_STATUS = 'sewage_selected_status';

const VILLAGE_DATA = 'village_selected_data';
const FOLK_DATA = 'folk_selected_data'

export default {
    getSelectedData() {
        if (localStorage.getItem(DATA) === null || localStorage.getItem(DATA) === 'null' || localStorage.getItem(DATA) === "") {
            return { 'ids': '', 'name': '全部' };
        }

        return JSON.parse(localStorage.getItem(DATA));
    },
    setSelectedData(house_data) {
        localStorage.setItem(DATA, JSON.stringify(house_data));
    },
    // 村落列表
    getVillageData() {
        if (localStorage.getItem(VILLAGE_DATA) === null || localStorage.getItem(VILLAGE_DATA) === 'null' || localStorage.getItem(VILLAGE_DATA) === "") {
            return { 'ids': '', 'name': '全部' };
        }

        return JSON.parse(localStorage.getItem(VILLAGE_DATA));
    },
    setVillageData(village_data) {
        localStorage.setItem(VILLAGE_DATA, JSON.stringify(village_data));
    },
    // 民宿列表
    getFolkData() {
        if (localStorage.getItem(FOLK_DATA) === null || localStorage.getItem(FOLK_DATA) === 'null' || localStorage.getItem(FOLK_DATA) === "") {
            return { 'ids': '', 'name': '全部' };
        }

        return JSON.parse(localStorage.getItem(FOLK_DATA));
    },
    setFolkData(data) {
        localStorage.setItem(FOLK_DATA, JSON.stringify(data));
    },

    setDangerData(house_data) {
        localStorage.setItem(DANGER_DATA, JSON.stringify(house_data));
    },
    getDangerData() {
        if (localStorage.getItem(DANGER_DATA) === null || localStorage.getItem(DANGER_DATA) === 'null' || localStorage.getItem(DANGER_DATA) === "") {
            return { 'ids': '', 'name': '全部' };
        }

        return JSON.parse(localStorage.getItem(DANGER_DATA));
    },
    setSewageData(sewage_data) {
        localStorage.setItem(SEWAGE_DATA, JSON.stringify(sewage_data));
    },
    getSewageData() {
        if (localStorage.getItem(SEWAGE_DATA) === null || localStorage.getItem(SEWAGE_DATA) === 'null' || localStorage.getItem(SEWAGE_DATA) === "") {
            return { 'ids': '', 'name': '全部' };
        }

        return JSON.parse(localStorage.getItem(SEWAGE_DATA));
    },
    getDangerData() {
        if (localStorage.getItem(DANGER_DATA) === null || localStorage.getItem(DANGER_DATA) === 'null' || localStorage.getItem(DANGER_DATA) === "") {
            return { 'ids': '', 'name': '全部' };
        }

        return JSON.parse(localStorage.getItem(DANGER_DATA));
    },
    removeSelectData() {
        localStorage.removeItem(DATA);
    },
    getSelectedStatus() {
        if (localStorage.getItem(STATUS) === null || localStorage.getItem(STATUS) === 'null' || localStorage.getItem(STATUS) === "") {
            return "";
        }

        return JSON.parse(localStorage.getItem(STATUS));
    },
    setSelectedStatus(status) {
        localStorage.setItem(STATUS, JSON.stringify(status));
    },



};